<template lang="html">
  <div id="branch-offices-page">

    <section class="container oversized-container main-section">
      <div class="row" v-if="isloading == false">
        <div class="col-12 col-s-title">
          <h2 class="title">Nuestras Ubicaciones</h2>
        </div>

        <div class="col-lg-4 col-xl-3 col-branch-office" v-for="(office, key) in contents" :key="key">
          <div class="box">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+office.imageUrl+')' }"></div>

            <div class="descr">
              <a target="_blank" class="map-icon" :href="office.url_maps">
                <i class="fas fa-map-marker-alt"></i>
              </a>

              <h6 class="name">{{ office.name }}</h6>
              <div v-html="office.address"></div>
              <div><b>Horario: </b><br>{{ office.schedule }}</div>
              <div><b>Telefono: </b><br>{{ office.phone }}</div>
              <div><b>WhatsApp: </b><br><a class="txt-whatsapp" target="_blank" :href="'https://wa.me/'+office.whatsapp">{{ office.whatsapp }}</a></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12 col-s-title">
          <h2 class="title">Nuestras Ubicaciones</h2>
          <br><br>
          <div class="fa-5x" style="text-align: center;"><i class="fas fa-spinner fa-pulse"></i></div>
        </div>

      </div>


      
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      isloading:true,
      contents: [
        /*{ urlMap: 'https://goo.gl/maps/ZNSS3oAeyQ7UFRyM9', imgUrl: 'public/images/pages/branch-offices/image-1.jpg',
          name: 'MATRIZ',
          address: `Dr. Arturo Guerra #361<br />
          Col. Braulio Maldonado, Tecate, B.C.<br />
          <strong>C.P. </strong> 21480<br />
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V:</strong> 7 a 8 | <strong>Sábado:</strong> 7 a 7 | <strong>Domingo:</strong> 8 a 5<br />
          <strong>Tel:</strong> 665 654 1651 y 665 654 0301<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6651217186"><strong>WhatsApp:</strong> 665 121 7186</a>`
        },
        { urlMap: 'https://goo.gl/maps/npWDiXZ2MVc2xtoS6', imgUrl: 'public/images/pages/branch-offices/image-2.jpg',
          name: 'ENCANTO',
          address: `KM. 1 Carretera<br />
          Tecate-Tijuana<br />
          Col. El Encanto, Tecate, B.C.<br />
          <strong>C.P. </strong>21440<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V:</strong> 7 a 5 | <strong>Sábado:</strong> 7 a 2 | <strong>Domingo:</strong> Cerrado<br />
          <strong>Tel:</strong> 665 118 88 97<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6651411887"><strong>WhatsApp:</strong> 665 141 1887</a>`
        },
        { urlMap: 'https://goo.gl/maps/LyFYgBfNJZHwhZ6T7', imgUrl: 'public/images/pages/branch-offices/image-3.jpg',
          name: 'DESCANSO',
          address: `Blvd. Luis Donaldo Colosio #130,<br />
          Col. Ampliación Descanso, Tecate, B.C.<br />
          <strong>C.P. </strong>21472<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 5 | <strong>Sábado: </strong>7 a 2 | <strong>Domingo: </strong>8 a 2<br />
          <strong>Tel: </strong> 6656551423<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6643752532"><strong>WhatsApp: </strong> 664 375 2532</a>
          `
        },
        { urlMap: 'https://goo.gl/maps/vUBqV5eqvRReWTjL8', imgUrl: 'public/images/pages/branch-offices/image-4.jpg',
          name: 'BENITEZ',
          address: `Blvd. Federico Benítez #50,<br />
          Col. Fortín de las Flores, Tijuana, B. C.<br />
          <strong>C.P. </strong>22114<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong> | <strong>Sábado: </strong> | <strong>Domingo: </strong><br />
          <strong>Tel: </strong>`
        },
        { urlMap: 'https://goo.gl/maps/vD74VzJcZHpf29hT9', imgUrl: 'public/images/pages/branch-offices/image-5.jpg',
          name: 'OTAY',
          address: `calle José Manuel Salvatierra #17602,<br />
          Garita de Otay, Tijuana, B. C.<br />
          <strong>C.P. </strong>22430<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 6 | <strong>Sábado: </strong>7 a 3 | <strong>Domingo: </strong>Cerrado<br />
          <strong>Tel: </strong> 664 363 7956<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6631277975"><strong>WhatsApp: </strong> 663 127 7975</a>`
        },
        { urlMap: 'https://goo.gl/maps/Ni9BhPEVdm18bAT56', imgUrl: 'public/images/pages/branch-offices/image-6.jpg',
          name: 'CUCAPAH',
          address: `Blvd. Cucapah #20162<br />
          Col. Buenos Aires Sur, Tijuana, B. C.<br />
          <strong>C.P. </strong>22207<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 6 | <strong>Sábado: </strong>8 a 4 | <strong>Domingo: </strong>8 a 3<br />
          <strong>Tel: </strong>664 701 65 56 y 664 629 4580<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6653924913"><strong>WhatsApp: </strong>665 392 4913</a><br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6631277975"><strong>WhatsApp: </strong>663 127 7975</a>
          `
        },
        { urlMap: 'https://goo.gl/maps/q8CxoLxUoGjrUZ9R8', imgUrl: 'public/images/pages/branch-offices/image-7.jpg',
          name: 'SANTA FE',
          address: `Av. Oriente #11999<br />
          Col. La Joya, Tijuana, B. C.<br />
          <strong>C.P. </strong>22506<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 7 | <strong>Sábado: </strong>8 a 6 | <strong>Domingo: </strong>8 a 4<br />
          <strong>Tel: </strong>664 399 4070<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6646878023"><strong>WhatsApp: </strong>664 687 8023</a>`
        },
        { urlMap: 'https://goo.gl/maps/TyUJ5kvtWVCEvrKd7', imgUrl: 'public/images/pages/branch-offices/image-8.jpg',
          name: 'FUNDADORES',
          address: `Blvd. Gustavo Aubanel #6131<br />
          Col. El Rubí, Tijuana, B. C.<br />
          <strong>C.P. </strong>22626<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 6 | <strong>Sábado: </strong>8 a 6 | <strong>Domingo: </strong>8 a 4<br />
          <strong>Tel: </strong>664 870 7694 y 664 870 7695 <br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6643873664"><strong>WhatsApp: </strong>664 387 3664</a>`
        },
        { urlMap: 'https://goo.gl/maps/Gbt4z4p7R6TezUcM9', imgUrl: 'public/images/pages/branch-offices/image-9.jpg',
          name: 'ROSARITO',
          address: `Blvd. Benito Juárez 268<br />
          Playas de Rosarito, B. C.<br />
          <strong>C.P. </strong>22703<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 6 | <strong>Sábado: </strong>8 a 4  | <strong>Domingo: </strong>8 a 4<br />
          <strong>Tel: </strong>661 112 5196<br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6611366874"><strong>WhatsApp: </strong>661 136 6874</span>`
        },
        { urlMap: 'https://goo.gl/maps/GphUQoDTuUA4pCou8', imgUrl: 'public/images/pages/branch-offices/image-10.jpg',
          name: 'RÍO',
          address: `Río Colorado 2396,<br />
          Col. Marrón, 22015 Tijuana, B.C.<br />
          <strong>C.P. </strong>22015<br>
          <strong class="d-inline-block mt-2">Horario</strong><br />
          <strong>L-V: </strong>7 a 7 | <strong>Sábado: </strong>8 a 6 | <strong>Domingo: </strong>8 a 4<br />
          <strong>Tel: </strong>663 203 0103 <br />
          <a class="txt-whatsapp" target="_blank" href="https://wa.me/6632030103"><strong>WhatsApp: </strong>663 203 0103</a>`
        },*/
      ],
    }
  },

  methods: {
    getContents: function(){
      axios.get(tools.url('/api/branchoffices')).then((response)=>{
        this.contents = response.data;
        var self = this;
        setTimeout(() => {
          self.isloading = false;
        }, 300);
      }).catch((error)=>{
        console.log(error);
        this.isloading = false;
      })
    },
  },

  mounted(){
     this.getContents();
  },
}
</script>
